import React, { useState, useEffect } from "react";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import { AuthContext } from "./context";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState("");
  const [user, setUser] = useState("");
  const base_url = process.env.REACT_APP_API_URI;

  useEffect(() => {
    const token_verification = async () => {
      let token = sessionStorage.getItem("token"); // get token
      if (!token || token === undefined || token === "") {
        setIsLoggedIn(false);
      } else {
        let result = await fetch(`${base_url}/user-info`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }).catch((err) => {
          console.log(err);
        });

        if (result && result.ok) {
          let data = await result.json();
          setIsLoggedIn(true);
          setUser(data);
        } else {
          sessionStorage.clear();
          setIsLoggedIn(false);
          setUser("");
        }
      }
    };
    token_verification();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 🔹 Post iframe height to parent (AEM) whenever content changes
  useEffect(() => {
    function sendHeight() {
      const height = document.documentElement.scrollHeight;
      window.parent.postMessage({ frameHeight: height }, "*");
    }

    // send immediately on mount
    sendHeight();

    // send on resize
    window.addEventListener("resize", sendHeight);

    // observe DOM changes
    const observer = new MutationObserver(sendHeight);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
    });

    return () => {
      window.removeEventListener("resize", sendHeight);
      observer.disconnect();
    };
  }, [isLoggedIn, user]); // re-run if login state or user changes

  return (
    <AuthContext.Provider
      value={{ base_url, isLoggedIn, setIsLoggedIn, user, setUser }}
    >
      <div className="my-3">
        {isLoggedIn === true && isLoggedIn !== "" ? (
          <Dashboard />
        ) : isLoggedIn === false && isLoggedIn !== "" ? (
          <Login />
        ) : (
          ""
        )}
      </div>
    </AuthContext.Provider>
  );
}

export default App;
